export default __webpack_public_path__ + "static/media/knowledge_base.1b75330c.svg";